import { Link } from 'react-router-dom';
import { ClockCircleOutlined, SwapRightOutlined } from '@ant-design/icons';
import { formatDate } from '../../utils/date';
import { toSeoUrl } from '../../utils/format';
import './Campaign.css';

function CampaignItem({ campaign }) {
  return (
    <Link to={`/campaign/${toSeoUrl(campaign.name)}/${campaign.id}`} className="campaign-card htv-card">
      {campaign.bannerUrl ? (
        <img className="campaign-card-image" alt="" src={campaign.bannerUrl} />
      ) : (
        <div className="campaign-card-image campaign-card-image-fallback" />
      )}
      <div className="campaign-card-body">
        <div className="htv-pill-row">
          {campaign.sportTypes.map((type) => (
            <span className="htv-pill" key={type}>
              {type}
            </span>
          ))}
        </div>
        <h2>{campaign.name}</h2>
        <p className="htv-muted">{campaign.description}</p>
        <div className="campaign-card-meta">
          <span>
            <ClockCircleOutlined /> {formatDate(campaign.startDate)} - {formatDate(campaign.endDate)}
          </span>
          <span>
            <SwapRightOutlined /> {campaign.raceDistances.join(' / ')} km
          </span>
        </div>
      </div>
    </Link>
  );
}

export default CampaignItem;
